import { createRouter } from '@tanstack/react-router';
import { Route as RootRoute } from './routes/__root';
import { Route as IndexRoute } from './routes/index';
import { Route as HealthRoute } from './routes/health';
import { Route as LoginRoute } from './routes/login';
import { Route as VozidlaRoute } from './routes/vozidla';
import { Route as UpravenaRoute } from './routes/upravena';
import { Route as VozidloDetailRoute } from './routes/vozidlo-detail';
import { Route as VozidloNovyRoute } from './routes/vozidlo-novy';
import { Route as VozidloUpravitRoute } from './routes/vozidlo-upravit';
import { Route as VozidloTiskRoute } from './routes/vozidlo-tisk';
import { Route as NabidkyRoute } from './routes/nabidky';
import { Route as NabidkaDetailRoute } from './routes/nabidka-detail';
import { Route as NabidkaTiskRoute } from './routes/nabidka-tisk';
import { Route as NabidkaWizardRoute } from './routes/vozidla-nabidka-wizard';
import { Route as SmluvyRoute } from './routes/smlouvy';
import { Route as SmlouvaDetailRoute } from './routes/smlouva-detail';
import { Route as SmlouvaProtokolRoute } from './routes/smlouva-protokol';
import { Route as SmlouvaProtokolLeasingRoute } from './routes/smlouva-protokol-leasing';
import { Route as SmlouvaTiskRoute } from './routes/smlouva-tisk';
import { Route as SmlouvaProtokolUpravitRoute } from './routes/smlouva-protokol-upravit';
import { Route as VyhodnoceniRoute } from './routes/vyhodnoceni';
import { Route as VozidlaSpravaRoute } from './routes/vozidla-sprava';
import { Route as ZakazniciRoute } from './routes/zakaznici';
import { Route as ZakazniciSpravaRoute } from './routes/zakaznici-sprava';
import { Route as ZakazniciVyhledavaniRoute } from './routes/zakaznici-vyhledavani';
import { Route as ZakaznikNovyRoute } from './routes/zakaznik-novy';
import { Route as ZakaznikDetailRoute } from './routes/zakaznik-detail';
import { Route as ZakaznikUpravitRoute } from './routes/zakaznik-upravit';
import { Route as KontaktyRoute } from './routes/kontakty';
import { Route as KontaktyPlanovaneRoute } from './routes/kontakty-planovane';
import { Route as KontaktyStatistikyRoute } from './routes/kontakty-statistiky';
import { Route as KontaktySpravaRoute } from './routes/kontakty-sprava';
import { Route as KontaktNovyRoute } from './routes/kontakt-novy';
import { Route as KontaktDetailRoute } from './routes/kontakt-detail';
import { Route as KontaktUpravitRoute } from './routes/kontakt-upravit';
import { Route as UkolyRoute } from './routes/ukoly';
import { Route as UkolNovyRoute } from './routes/ukol-novy';
import { Route as UkolDetailRoute } from './routes/ukol-detail';
import { Route as UkolUpravitRoute } from './routes/ukol-upravit';
import { Route as ServisPlanovaniRoute } from './routes/servis-planovani';
import { Route as ServisVyhledaniRoute } from './routes/servis-vyhledani';
import { Route as ServisUskladneniRoute } from './routes/servis-uskladneni';
import { Route as ServisUskladneniDetailRoute } from './routes/servis-uskladneni-detail';
import { Route as ServisHistorieRoute } from './routes/servis-historie';
import { Route as ServisLokaceRoute } from './routes/servis-lokace';
import { Route as ServisSpravaRoute } from './routes/servis-sprava';
import { Route as LeasingRoute } from './routes/leasing';
import { Route as LeasingDetailRoute } from './routes/leasing-detail';
import { Route as LeasingNabidkaDetailRoute } from './routes/leasing-nabidka-detail';
import { Route as LeasingWizardRoute } from './routes/leasing-wizard';
import { Route as LeasingNabidkaTiskRoute } from './routes/leasing-nabidka-tisk';
import { Route as LeasingSmlouvaTiskRoute } from './routes/leasing-smlouva-tisk';
import { Route as LeasingProtokolRoute } from './routes/leasing-protokol';
import { Route as LeasingProtokolUpravitRoute } from './routes/leasing-protokol-upravit';
import { Route as LeasingFinancovaniRoute } from './routes/leasing-financovani';
import { Route as LeasingKalkulaceRoute } from './routes/leasing-kalkulace';
import { Route as LeasingNabidkaKalkulaceRoute } from './routes/leasing-nabidka-kalkulace';
import { Route as LeasingVyhodnoceniRoute } from './routes/leasing-vyhodnoceni';
import { Route as LeasingPrehledyRoute } from './routes/leasing-prehledy';
import { Route as LeasingPrehledTiskRoute } from './routes/leasing-prehled-tisk';
import { Route as EbmReportTiskRoute } from './routes/ebm-report-tisk';
import { Route as OjetaListRoute } from './routes/ojeta-vozidla';
import { Route as OjetaSpravaRoute } from './routes/ojeta-vozidla-sprava';
import { Route as OjetoDetailRoute } from './routes/ojeto-detail';
import { Route as OjetoNovyRoute } from './routes/ojeto-novy';
import { Route as OjetaUpravenaRoute } from './routes/ojeta-upravena';
import { Route as OjetaNabidkyRoute } from './routes/ojeta-nabidky';
import { Route as OjetaNabidkaDetailRoute } from './routes/ojeta-nabidka-detail';
import { Route as OjetaNabidkaTiskRoute } from './routes/ojeta-nabidka-tisk';
import { Route as OjetaNabidkaWizardRoute } from './routes/ojeta-nabidka-wizard';
import { Route as OjetaSmluvyRoute } from './routes/ojeta-smlouvy';
import { Route as OjetaSmlouvaDetailRoute } from './routes/ojeta-smlouva-detail';
import { Route as OjetaSmlouvaTiskRoute } from './routes/ojeta-smlouva-tisk';
import { Route as OjetaSmlouvaWizardRoute } from './routes/ojeta-smlouva-wizard';
import { Route as OjetaSmlouvaProtokolRoute } from './routes/ojeta-smlouva-protokol';
import { Route as OjetaSmlouvaProtokolUpravitRoute } from './routes/ojeta-smlouva-protokol-upravit';
import { Route as OjetaVykupRoute } from './routes/ojeta-vykup';
import { Route as OjetaVykupDetailRoute } from './routes/ojeta-vykup-detail';
import { Route as OjetaVykupTiskRoute } from './routes/ojeta-vykup-tisk';
import { Route as OjetaVykupWizardRoute } from './routes/ojeta-vykup-wizard';
import { Route as PostaSpravaRoute } from './routes/posta-sprava';
import { Route as PostaSpolecnostNovaRoute } from './routes/posta-spolecnost-nova';
import { Route as PostaRoute } from './routes/posta';
import { Route as PostaDetailRoute } from './routes/posta-detail';
import { Route as PostaNovyRoute } from './routes/posta-novy';
import { Route as PostaUpravitRoute } from './routes/posta-upravit';
import { Route as KalendarRoute } from './routes/kalendar';
import { Route as PujcovnaRoute } from './routes/pujcovna';
import { Route as PujcovnaSpravaRoute } from './routes/pujcovna-sprava';
import { Route as PujcovnaPrehledRoute } from './routes/pujcovna-prehled';
import { Route as PujcovnaUhradyRoute } from './routes/pujcovna-uhrady';
import { Route as PujcovnaRezervaceRoute } from './routes/pujcovna-rezervace';
import { Route as PujcovnaVozidlaRoute } from './routes/pujcovna-vozidla';
import { Route as PujcovnaSmlouvaTiskRoute } from './routes/pujcovna-smlouva-tisk';
import { Route as PujcovnaProtokolTiskRoute } from './routes/pujcovna-protokol-tisk';
import { Route as PujcovnaPobockaNovaRoute } from './routes/pujcovna-pobocka-nova';
import { Route as PujcovnaTarifNovyRoute } from './routes/pujcovna-tarif-novy';
import { Route as PujcovnaPojistovnaNovaRoute } from './routes/pujcovna-pojistovna-nova';
import { Route as PujcovnaVozidloNoveRoute } from './routes/pujcovna-vozidlo-nove';
import { Route as ManagementRoute } from './routes/management';
import { Route as PlatformaRoute } from './routes/platforma';
import { Route as PlatformaKategorieNovaRoute } from './routes/platforma-pujcovna-kategorie-nova';

const routeTree = RootRoute.addChildren([
  IndexRoute,
  HealthRoute,
  LoginRoute,
  VozidlaRoute,
  UpravenaRoute,
  VozidloDetailRoute,
  VozidloNovyRoute,
  VozidloUpravitRoute,
  VozidloTiskRoute,
  NabidkyRoute,
  NabidkaDetailRoute,
  NabidkaTiskRoute,
  NabidkaWizardRoute,
  SmluvyRoute,
  SmlouvaDetailRoute,
  SmlouvaProtokolRoute,
  SmlouvaProtokolLeasingRoute,
  SmlouvaProtokolUpravitRoute,
  SmlouvaTiskRoute,
  VyhodnoceniRoute,
  VozidlaSpravaRoute,
  ZakazniciRoute,
  ZakazniciSpravaRoute,
  ZakazniciVyhledavaniRoute,
  ZakaznikNovyRoute,
  ZakaznikDetailRoute,
  ZakaznikUpravitRoute,
  KontaktyRoute,
  KontaktyPlanovaneRoute,
  KontaktyStatistikyRoute,
  KontaktySpravaRoute,
  KontaktNovyRoute,
  KontaktDetailRoute,
  KontaktUpravitRoute,
  UkolyRoute,
  UkolNovyRoute,
  UkolDetailRoute,
  UkolUpravitRoute,
  ServisPlanovaniRoute,
  ServisVyhledaniRoute,
  ServisUskladneniRoute,
  ServisUskladneniDetailRoute,
  ServisHistorieRoute,
  ServisLokaceRoute,
  ServisSpravaRoute,
  LeasingRoute,
  LeasingDetailRoute,
  LeasingNabidkaDetailRoute,
  LeasingWizardRoute,
  LeasingNabidkaTiskRoute,
  LeasingSmlouvaTiskRoute,
  LeasingProtokolRoute,
  LeasingProtokolUpravitRoute,
  LeasingFinancovaniRoute,
  LeasingKalkulaceRoute,
  LeasingNabidkaKalkulaceRoute,
  LeasingVyhodnoceniRoute,
  LeasingPrehledyRoute,
  LeasingPrehledTiskRoute,
  EbmReportTiskRoute,
  OjetaListRoute,
  OjetaSpravaRoute,
  OjetoDetailRoute,
  OjetoNovyRoute,
  OjetaUpravenaRoute,
  OjetaNabidkyRoute,
  OjetaNabidkaDetailRoute,
  OjetaNabidkaTiskRoute,
  OjetaNabidkaWizardRoute,
  OjetaSmluvyRoute,
  OjetaSmlouvaDetailRoute,
  OjetaSmlouvaTiskRoute,
  OjetaSmlouvaWizardRoute,
  OjetaSmlouvaProtokolRoute,
  OjetaSmlouvaProtokolUpravitRoute,
  OjetaVykupRoute,
  OjetaVykupDetailRoute,
  OjetaVykupTiskRoute,
  OjetaVykupWizardRoute,
  PostaRoute,
  PostaSpravaRoute,
  PostaSpolecnostNovaRoute,
  PostaNovyRoute,
  PostaDetailRoute,
  PostaUpravitRoute,
  KalendarRoute,
  PujcovnaRoute,
  PujcovnaSpravaRoute,
  PujcovnaPrehledRoute,
  PujcovnaUhradyRoute,
  PujcovnaRezervaceRoute,
  PujcovnaVozidlaRoute,
  PujcovnaSmlouvaTiskRoute,
  PujcovnaProtokolTiskRoute,
  PujcovnaPobockaNovaRoute,
  PujcovnaTarifNovyRoute,
  PujcovnaPojistovnaNovaRoute,
  PujcovnaVozidloNoveRoute,
  ManagementRoute,
  PlatformaRoute,
  PlatformaKategorieNovaRoute,
]);

export const router = createRouter({
  routeTree,
  defaultPreload: 'intent',
  // Crossfade routes via the View Transitions API (Chromium-only today,
  // Safari-supported soon). On unsupported browsers it's a graceful no-op.
  defaultViewTransition: true,
});

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}
